import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-verkeerslicht',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVerkeerslicht {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M17.8 28h.39c3.76 0 6.8-3.06 6.8-6.84V6.84c0-3.78-3.05-6.84-6.8-6.84h-.39C14.04 0 11 3.06 11 6.84v14.33c0 3.78 3.05 6.84 6.8 6.84ZM18 4.69a1.961 1.961 0 0 1 0 3.92 1.961 1.961 0 0 1 0-3.92M18 12a1.961 1.961 0 0 1 0 3.92A1.961 1.961 0 0 1 18 12m0 7.31a1.961 1.961 0 0 1 0 3.92 1.961 1.961 0 0 1 0-3.92M16.02 32H20a1 1 0 0 0 0-2h-3.98a1 1 0 0 0 0 2m0 4H20a1 1 0 0 0 0-2h-3.98a1 1 0 0 0 0 2"/>
</svg>

    );
  }
}
